// Helpers para gerar JSON-LD focado em SEO local (Goiânia).

const SITE_URL = "https://acesso.srv.br";
const LB_ID = `${SITE_URL}/#localbusiness`;
const ORG_ID = `${SITE_URL}/#organization`;

export function breadcrumbJsonLd(items: { name: string; path: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE_URL}${it.path}`,
    })),
  };
}

export function serviceJsonLd(opts: {
  name: string;
  description: string;
  serviceType?: string;
  url: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: opts.name,
    description: opts.description,
    serviceType: opts.serviceType ?? opts.name,
    url: `${SITE_URL}${opts.url}`,
    provider: { "@id": LB_ID },
    areaServed: [
      { "@type": "City", name: "Goiânia" },
      { "@type": "City", name: "Aparecida de Goiânia" },
      { "@type": "City", name: "Anápolis" },
      { "@type": "State", name: "Goiás" },
    ],
  };
}

export { SITE_URL, LB_ID, ORG_ID };
